import { html } from "lit";
import type { ExploreSubTab } from "../navigation";
import { renderCapabilities, type CapabilitiesProps } from "./capabilities";
import { renderMcpView, type McpViewProps } from "./mcp";

export type ExploreProps = {
  subTab: ExploreSubTab;
  onSubTabChange: (next: ExploreSubTab) => void;
  capabilities: CapabilitiesProps;
  mcp: McpViewProps;
};

export function renderExplore(props: ExploreProps) {
  return html`
    <div class="chip-row" style="margin-bottom: 20px;">
      <button
        class="chip chip-toggle ${props.subTab === "mcp" ? "active" : ""}"
        @click=${() => props.onSubTabChange("mcp")}
      >MCP Servers</button>
      <button
        class="chip chip-toggle ${props.subTab === "usecases" ? "active" : ""}"
        @click=${() => props.onSubTabChange("usecases")}
      >Use Cases</button>
    </div>
    ${props.subTab === "mcp"
      ? renderMcpView(props.mcp)
      : renderCapabilities(props.capabilities)}
  `;
}
